import { useId } from "react";
import { parseDatum, formatDatum, type UnscharfesDatum } from "@stammbaum/shared";

/**
 * Ein Textfeld für genealogische Daten.
 *
 * Statt drei Auswahlfeldern für Tag, Monat und Jahr tippt man einfach, was
 * in der Urkunde steht — und sieht darunter sofort, wie es verstanden wurde.
 * Das ist der einzige Weg, "um 1750" ehrlich zu erfassen, ohne dass jemand
 * einen 1. Jänner erfindet.
 */
export function DatumFeld({
  beschriftung,
  wert,
  onChange,
}: {
  beschriftung: string;
  wert: string;
  onChange: (text: string) => void;
}) {
  const id = useId();
  const gedeutet: UnscharfesDatum | null = wert.trim() ? parseDatum(wert) : null;
  const unklar = gedeutet !== null && gedeutet.von === null && gedeutet.bis === null;

  return (
    <div>
      <label htmlFor={id} className="text-sm text-black/60 dark:text-white/60">
        {beschriftung}
      </label>
      <input
        id={id}
        value={wert}
        onChange={(e) => onChange(e.target.value)}
        placeholder="z.B. 12.3.1887, März 1887, 1887, um 1750, vor 1900"
        className="mt-1 w-full rounded-lg border border-black/15 bg-white px-3 py-2
                   outline-none focus:border-black/40 dark:border-white/15 dark:bg-neutral-800"
      />
      <p className="mt-1 h-4 text-xs text-black/45 dark:text-white/45">
        {gedeutet &&
          (unklar ? (
            <span className="text-amber-700 dark:text-amber-500">
              nicht gedeutet — wird als Text übernommen
            </span>
          ) : (
            <>
              gelesen als <strong className="font-medium">{formatDatum(gedeutet)}</strong>
              {gedeutet.genauigkeit !== "exakt" && ` (${gedeutet.genauigkeit})`}
            </>
          ))}
      </p>
    </div>
  );
}
